// @flow

import compose from 'lodash/fp/compose';
import slice from 'lodash/fp/slice';
import sortBy from 'lodash/fp/sortBy';
import reverse from 'lodash/fp/reverse';
import filter from 'lodash/fp/filter';
import type { Rank } from 'type/type';

export const pickRank = (originalRanks: Rank[]) => compose(slice(0)(3), reverse, sortBy('total'))(originalRanks);

export const getFinalResultRank = (originalRanks: Rank[]) => compose(
  pickRank,
  filter(rank => !rank.stageId),
)(originalRanks);
